import { Button, ButtonProps, Stack, Typography } from "components";

type ButtonKeys = "iconEnd" | "link" | "onClick";

interface PostCheckoutButton extends Pick<ButtonProps, ButtonKeys> {
  label: string;
}

interface PostCheckoutProps {
  title: string;
  message: string;
  button: PostCheckoutButton;
}

const PostCheckout: React.FC<PostCheckoutProps> = ({
  title,
  message,
  button,
}) => (
  <Stack
    direction="column"
    placeItems="center"
    gap={3}
    style={{ padding: "32px 0" }}
  >
    <Typography component="h1" weight={500}>
      {title}
    </Typography>
    <Typography
      component="p"
      color="#757575"
      align="center"
      style={{ maxWidth: "50ch" }}
    >
      {message}
    </Typography>
    <Button
      filled
      iconEnd={button.iconEnd}
      link={button.link}
      onClick={button.onClick}
    >
      {button.label}
    </Button>
  </Stack>
);

export { PostCheckout };
